import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
// import { DRAWER_WIDTH } from "src/utils/constants";

export const MarketOptionsStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      overflowX: "auto",
      overflowY: "hidden",
      height: "100%",
      alignItems: "flex-end",
      [theme.breakpoints.up("md")]: {
        minWidth: "680px",
      },
    },
    linksContainer: {
      marginRight: "15px",
      marginBottom: "10px",
      marginLeft: "10px",
      "& .Mui-selected": {
        // marginTop: "10px",
        fontWeight: 600,
        fontSize: "16px",
        border: "0px !important",
        backgroundColor: "#fc4c4c  !important",
        boxShadow: "0px 5px 10px rgba(253, 139, 139, 0.5)",
        color: "#ffffff !important",
        textTransform: "none",
      },
    },
    link: {
      border: "none",
      borderRadius: "20px",
      padding: "5px 10px",
    },
  }),
);
